import { useFormik } from 'formik';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import Select from 'react-select';
import { Card, CardFooter } from '@components/card/card';
import { CardBody, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useGetPersons from '@hooks/HR/use-get-persons';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import {
  getReceiveTransactionsById,
  updateReceiveTransactions
} from '@store/INV/Transactions/InvReceive/invReceiveSlice';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useGetTransactionTypesReceiveList from '@hooks/INV/InvReceive/useGetTransactionTypesReceiveList';
// import Reference from '../Reference/Reference';
import { TreeSelect } from 'antd';
import useGetCustomersList from '@hooks/NTX/Peoples/useGetCustomersList';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
import ReceiveLines from './ReceiveLines';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
import useGetSubinventoryList from '@hooks/INV/Inventories/useGetSubinventoryList';
// import { getPersonId } from  '@store/Login2/authSelectors';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import { useEffect, useMemo, useState } from 'react';
import Loading from '@components/Shared/Loader/Loading';
import NeatixModal from '@components/Modal/NeatixModal';
import JournalsByReference from '@pages/Finance/Journals/JournalsByReference/JournalsByReference';
import SwalAlert from '@components/Shared/Alert/SwalAlert';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import { activeFinanceSelector } from '@store/Login/authSelectors';

import FileUpload from '@components/Files/FileUpload';

type UiAttachment = { id?: string; name: string; url: string };

const mapServerAttachments = (attachment?: any[]): UiAttachment[] =>
  (attachment ?? []).map(a => ({
    id: a.id,
    name: a.fileName,
    url: a.filePath
  }));

const Update = () => {
  const activeFinance = useAppSelector(activeFinanceSelector);
  const { HasPermission } = usePermissions();
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const Navigate = useNavigate();
  const [show, setShow] = useState(false);

  const { dataEmployees, loading, error } = useGetPersons();
  const { OperatingUnitOptions, loading: loading1, error: error1 } = useGetOperatingUnitWithPermission();
  const { InventoryOptions, loading: loading2, error: error2 } = useGetInventoryWithPermission();
  const { TreeSubInventoryData, loading: loading3, error: error3 } = useGetSubinventoryList();
  const { treeCustomerData, loading: loading4, error: error4 } = useGetCustomersList();
  const { treeSuppliersData, loading: loading5, error: error5 } = useGetSuppliersList();
  const { OptionsTransactionTypes, loading: loading6, error: error6 } = useGetTransactionTypesReceiveList();

  useEffect(() => {
    if (id) {
      dispatch(getReceiveTransactionsById(id));
    }
  }, [dispatch, id]);
  const { InvReceiveById: data, loading: loagingById, error: errorById } = useAppSelector(s => s.InvReceive);

  // console.log(JSON.stringify(data));

  const formik = useFormik({
    initialValues: {
      supplierInvoiceNum: data ? data.supplierInvoiceNum : '',
      code: data?.code?.substring(0, 3) ?? '',
      transactionDate: data ? data.transactionDate : '',
      description: data ? data.description : '',
      branchId: data ? data.branchId : '',
      transactionAmount: data ? data.transactionAmount : 0,
      referenceType: data ? data.referenceType : '',
      referenceId: data ? data.referenceId : null,
      referenceCode: data ? data.referenceCode : '',
      supplierId: data ? data.supplierId : null,
      customerId: data ? data.customerId : null,
      personId: data ? data.personId : null,
      inventoryId: data ? data.inventoryId : null,
      subInventoryId: data ? data.subInventoryId : null,
      address: data ? data.address : '',
      note: data ? data.note : '',
      postedFlag: data ? data.postedFlag : false,

      // ... باقي الحقول
      attachments: mapServerAttachments(data?.attachment), // ✅ ملفات موجودة
      fileAttachment: [] as File[], // ✅ ملفات جديدة (رفع)
      //
      IsUpdateAttachment: false,

      materialTransactionsLineList:
        data?.materialTransactionsLineList?.map(item => ({
          id: item.id || null,
          transactionItemId: item.transactionItemId,
          transactionUom: item.transactionUom,
          unitPrice: item.unitPrice,
          // unitPrice: 0,
          transactionQuantityIn: item.transactionQuantityIn,
          transactionQuantityOut: 0,
          inventoryId: null,
          discount: 0,
          currencyCode: '',
          currencyConversionRate: 0,
          referenceIdMaster: item.referenceIdMaster || null,
          referenceIdLine: item.referenceIdLine || null,
          transactionTypeId: null,
          batchId: null,
          lotId: item.lotId || null
        })) ?? []
    },
    enableReinitialize: true,
    onSubmit: values => {
      if (data.postedFlag === true) {
        SwalAlert({
          text: t('CannotEditAfterPosting')
        });
        formik.setSubmitting(false);
        return;
      }

      dispatch(
        updateReceiveTransactions({
          id: id,
          code: values.code,
          transactionDate: values.transactionDate,
          description: values.description,
          branchId: values.branchId,
          transactionAmount: 0,
          supplierId: values.supplierId || null,
          customerId: values.customerId || null,
          personId: values.personId || null,
          inventoryId: values.inventoryId,
          address: values.address,
          note: values.note,
          supplierInvoiceNum: values.supplierInvoiceNum,
          //
          fileAttachment: values.fileAttachment,
          IsUpdateAttachment: values.IsUpdateAttachment,
          //
          materialTransactionsLineList: formik.values.materialTransactionsLineList?.map(item => ({
            id: item.id,
            transactionItemId: item.transactionItemId,
            transactionUom: item.transactionUom,
            unitPrice: item.unitPrice,
            transactionQuantityIn: item.transactionQuantityIn,
            transactionQuantityOut: 0,
            referenceIdMaster: item.referenceIdMaster || null,
            referenceIdLine: item.referenceIdLine || null,
            inventoryId: null,
            discount: 0,
            currencyCode: '',
            currencyConversionRate: 0,
            lotId: item.lotId || null,
            transactionTypeId: null,
            batchId: null
          }))
        })
      )
        .unwrap()
        .then((res: any) => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Edit' });
            Navigate('/INV/Transactions/InvReceive', { replace: true });
          } else {
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          CustomAlert({ action: 'Error' });
        })
        .finally(() => formik.setSubmitting(false));
    }
  });

  const { values, handleChange: formikhandleChange, errors, touched } = formik;

  const isLoading = useMemo(
    () => loagingById || loading || loading1 || loading2 || loading3 || loading4 || loading5 || loading6,
    [loagingById, loading, loading1, loading2, loading3, loading4, loading5, loading6]
  );

  const isError = useMemo(
    () => errorById || error || error1 || error2 || error3 || error4 || error5 || error6,
    [errorById, error, error1, error2, error3, error4, error5, error6]
  );

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: t('Home'),
              link: ':moduleHome'
            },
            {
              name: t('ReceivePermission'),
              link: ''
            },
            {
              name: t('EditReceivePermission'),
              link: null
            }
          ]}
          PageName={t('EditReceivePermission')}
          subtitle={data.code}
        />
      </div>
      <Form onSubmit={formik.handleSubmit}>
        <Loading loading={isLoading} error={isError}>
          <Card>
            {data.postedFlag === true && (
              <div className='alert alert-info d-flex align-items-center justify-content-between m-2'>
                <div className='d-flex align-items-center'>
                  <i className='fas fa-info-circle fa-2x me-3'></i>
                  <div>
                    {/* <h5 className='alert-heading'>{t('عملية مرحلة')}</h5>
                <p className='mb-0'>{t('لا يمكن تعديل عمليات الإضـافة المرحلة في النظام')}</p> */}

                    <h5 className='alert-heading'>{i18n.language === 'en' ? 'Posted Transaction' : 'عملية مرحلة'}</h5>
                    <p className='mb-0'>
                      {i18n.language === 'en'
                        ? 'Posted addition transactions cannot be modified in the system.'
                        : 'لا يمكن تعديل عمليات الإضـافة المرحلة في النظام'}
                    </p>
                  </div>
                </div>

                {/* الزر في الطرف الآخر */}
                <button
                  hidden={activeFinance !== true}
                  type='button'
                  className='btn btn-sm btn-info'
                  onClick={() => setShow(true)}
                >
                  <i className='fa fa-info-circle fa-fw me-1'></i>
                  {t('JournalDetails')}
                </button>
              </div>
            )}

            <CardBody>
              <div className='row '>
                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Date')}</label>
                    <Form.Control
                      disabled={data.postedFlag === true}
                      className='form-control  text-center'
                      type='date'
                      name='transactionDate'
                      onChange={formikhandleChange}
                      value={values.transactionDate?.toString()?.split('T')[0] || ''}
                    />
                    <div className='text-danger small'>
                      {formik.touched.transactionDate && formik.errors.transactionDate}
                    </div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('OperatingUnit')}</label>
                    <Select
                      isDisabled
                      classNamePrefix='react-select'
                      isLoading={loading1}
                      isSearchable={true}
                      isClearable
                      options={OperatingUnitOptions}
                      value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.branchId)}
                      placeholder={t('Choose')}
                    />
                    <div className='text-danger small'>{formik.touched.branchId && formik.errors.branchId}</div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Inventory')}</label>
                    <Select
                      isDisabled
                      classNamePrefix='react-select'
                      isLoading={loading2}
                      isSearchable={true}
                      isClearable
                      options={InventoryOptions}
                      value={InventoryOptions?.find((f: any) => f.value === values.inventoryId)}
                      placeholder={t('Choose')}
                    />
                    <div className='text-danger small'>{formik.touched.inventoryId && formik.errors.inventoryId}</div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('SubInventory')}</label>
                    <TreeSelect
                      disabled={data.postedFlag === true}
                      loading={loading3}
                      showSearch
                      className='w-100'
                      treeLine
                      placeholder={t('Choose')}
                      allowClear
                      treeDefaultExpandAll={false}
                      value={values.subInventoryId}
                      onChange={(option: any) => {
                        formik.setFieldValue('subInventoryId', option === null ? null : option);
                      }}
                      treeData={TreeSubInventoryData?.filter(f => f.parentId === values.inventoryId)}
                      treeNodeFilterProp='title'
                    />
                    <div className='text-danger small'>
                      {formik.touched.subInventoryId && formik.errors.subInventoryId}
                    </div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('TransactionType')}</label>
                    <Select
                      isDisabled
                      classNamePrefix='react-select'
                      isLoading={loading6}
                      isSearchable={true}
                      isClearable
                      options={OptionsTransactionTypes}
                      value={OptionsTransactionTypes.find(f => f.value === values.code)}
                      onChange={(option: any) => {
                        formik.setFieldValue('code', option === null ? null : option.value);
                        formik.setFieldValue('materialTransactionsLineList', []);
                      }}
                      placeholder={t('Choose')}
                    />
                    <div className='text-danger small'>{formik.touched.code && formik.errors.code}</div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Reference')}</label>
                    <Form.Control
                      disabled
                      className='form-control'
                      type='text'
                      onChange={formikhandleChange}
                      value={values.referenceCode || ''}
                    />
                  </div>
                </div>

                {['SPR', 'POR'].includes(values.code) && (
                  <>
                    <div className='col-lg-3'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('Supplier')}</label>
                        <TreeSelect
                          disabled
                          showSearch
                          className='w-100'
                          treeLine
                          placeholder={t('Choose')}
                          allowClear
                          treeDefaultExpandAll={false}
                          value={values.supplierId}
                          onChange={(option: any) => {
                            formik.setFieldValue('supplierId', option === null ? null : option);
                          }}
                          loading={loading5}
                          treeData={treeSuppliersData}
                          treeNodeFilterProp='title'
                        />
                        <div className='text-danger small'>{formik.touched.supplierId && formik.errors.supplierId}</div>
                      </div>
                    </div>

                    <div className='col-lg-3'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('SupplierInvoiceNumber')}</label>
                        <Form.Control
                          disabled={data.postedFlag === true}
                          className='form-control  text-center'
                          type='text'
                          name='supplierInvoiceNum'
                          onChange={formikhandleChange}
                          value={values.supplierInvoiceNum || ''}
                        />
                        <div className='text-danger small'>
                          {formik.touched.supplierInvoiceNum && formik.errors.supplierInvoiceNum}
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {['INV', 'SOI'].includes(values.code) && (
                  <div className='col-lg-3'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('Customer')}</label>
                      <TreeSelect
                        showSearch
                        className='w-100'
                        treeLine
                        allowClear
                        treeDefaultExpandAll={false}
                        value={values.customerId}
                        onChange={(option: any) => {
                          formik.setFieldValue('customerId', option === null ? null : option);
                        }}
                        loading={loading4}
                        treeData={treeCustomerData}
                        treeNodeFilterProp='title'
                        placeholder={t('Choose')}
                      />
                      <div className='text-danger small'>{formik.touched.customerId && formik.errors.customerId}</div>
                    </div>
                  </div>
                )}

                {/* <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('StoreKeeper')}</label>
                    <Select
                      isDisabled
                      classNamePrefix='react-select'
                      isLoading={loading}
                      isSearchable={true}
                      isClearable
                      name='personId'
                      options={dataEmployees}
                      value={dataEmployees?.find((f: any) => f.value === values.personId)}
                      onChange={(option: any) => {
                        formik.setFieldValue('personId', option === null ? null : option.value);
                      }}
                      placeholder={t('Choose')}
                    />
                  </div>
                </div> */}
              </div>
              <div className='col-lg-12'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('Description')}</label>
                  <Form.Control
                    autoComplete='off'
                    className='form-control'
                    as='textarea'
                    rows={1}
                    name='description'
                    onChange={formik.handleChange}
                    value={values.description}
                  />
                </div>
              </div>
            </CardBody>

            <CardFooter className='shadow-sm px-0  '>
              {<ReceiveLines key={id} formik={formik} isUpdate={true} />}
            </CardFooter>
          </Card>

          <Card className='mt-3'>
            <div className='card-header'>
              <span className='m-0'>{t('Attachments')}</span>
            </div>

            <CardBody>
              {/* لو العملية مرحلة/posted تقدر تعرضها قراءة فقط */}
              {data?.postedFlag === true ? (
                <ul className='list-group'>
                  {(formik.values.attachments ?? []).map((a: any, i: number) => (
                    <li key={i} className='list-group-item d-flex justify-content-between align-items-center'>
                      {'url' in a ? (
                        <a href={a.url} target='_blank' rel='noopener noreferrer' className='text-decoration-none'>
                          {a.name}
                        </a>
                      ) : (
                        <span>{a.name}</span>
                      )}
                    </li>
                  ))}
                </ul>
              ) : (
                <FileUpload
                  attachments={formik.values.attachments}
                  // setAttachments={setFormikAttachments}
                  setAttachments={(updater: any) => {
                    const next = typeof updater === 'function' ? updater(formik.values.fileAttachment) : updater;

                    formik.setFieldValue('fileAttachment', next);
                    formik.setFieldValue('IsUpdateAttachment', true);
                    // اختياري لو عندك فاليديشن على المرفقات
                    // formik.setFieldTouched('fileAttachment', true, true);
                  }}
                  multiple={true}
                />
              )}
            </CardBody>
          </Card>

          <Card className='p-2 mt-3'>
            <div className='text-end  '>
              {HasPermission('INVEditInvReceive') && (
                <button
                  disabled={formik.isSubmitting || data?.postedFlag}
                  type='submit'
                  className='btn btn-lg me-1 btn-theme rounded-2 '
                >
                  {formik.isSubmitting ? (
                    <div className='spinner-border spinner-border-sm me-2'></div>
                  ) : data?.postedFlag ? (
                    <i className='fas fa-check-circle fa-lg fa-fw me-2'></i>
                  ) : (
                    <i className='fas fa-save fa-lg fa-fw me-2'></i>
                  )}
                  {data?.postedFlag ? t('RecordPosted') : t('Save')}
                </button>
              )}
              <button type='button' className='btn btn-lg  me-1 btn-default rounded-2 ' onClick={() => Navigate(-1)}>
                <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
              </button>
            </div>
          </Card>
        </Loading>
      </Form>
      <NeatixModal show={show} setShow={setShow} size='xl' title='تفاصيل القيد'>
        {id && <JournalsByReference referenceId={id} />}
      </NeatixModal>
    </>
  );
};

export default Update;
